import React from 'react';
import { Box, Modal, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AttivitaInsertEdit from '../AttivitaInsertEdit';

const ActivityEditModal = ({ open, idProgetto, attivita, onClose, onSaved, onDelete }) => (
    <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-title"
        BackdropProps={{ onClick: (e) => e.stopPropagation() }}
    >
        <Box
            sx={{
                position: 'absolute', top: '50%', left: '50%',
                transform: 'translate(-50%, -50%)',
                width: { xs: '90%', sm: 500 },
                bgcolor: 'background.paper', boxShadow: 24, borderRadius: 3,
                overflow: 'hidden', outline: 'none',
            }}
        >
            <Box
                display="flex" justifyContent="space-between" alignItems="center" p={2}
                sx={{ borderBottom: '1px solid #eee', bgcolor: 'primary.main', color: 'white' }}
            >
                <Typography variant="h6" fontWeight={600}>
                    {attivita ? 'Modifica Attività' : 'Nuova Attività'}
                </Typography>
                <IconButton onClick={onClose} size="small" sx={{ color: 'white' }}>
                    <CloseIcon />
                </IconButton>
            </Box>
            <Box p={3} sx={{ maxHeight: '80vh', overflowY: 'auto' }}>
                <AttivitaInsertEdit
                    idProgetto={idProgetto}
                    existingData={attivita}
                    onSave={onSaved}
                    onDelete={onDelete}
                />
            </Box>
        </Box>
    </Modal>
);

export default ActivityEditModal;